import { Box } from '@mui/material';
import Required from './Required';
import Recommended from './Recommended';
import { SparkButton } from 'sharedComponents/UI';
import { useSparkDiagnostics } from 'hooks/spark';

type PublishChecklistFormProps = {
  sparkID: string;
};

function PublishChecklistForm({ sparkID }: PublishChecklistFormProps) {
  const { sparkDiagnostics } = useSparkDiagnostics(sparkID);

  const sparkDiagnosticsChecklist = sparkDiagnostics?.publish.checklist;
  const requiredActions = sparkDiagnosticsChecklist?.required;
  const recommendedActions = sparkDiagnosticsChecklist?.recommended;

  return (
    <Box
      width='100%'
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      height='100%'
    >
      <Box>
        {requiredActions && <Required requiredActions={requiredActions} />}
        {recommendedActions && (
          <Recommended recommendedActions={recommendedActions} />
        )}
      </Box>
    </Box>
  );
}

export default PublishChecklistForm;
